import { useState } from "react";

export const CsvImportForm = () => {
  const [isSubmitting, setSubmitting] = useState(false);
  const [hasFiles, setHasFiles] = useState(false);

  const handleSubmit = () => setSubmitting(true);
  const handleChange = (e) => setHasFiles(!!e.target.files.length);

  return (
    <div className="position-relative">
      <form
        className={isSubmitting ? "sr-only" : ""}
        method="post"
        action="/import"
        encType="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <div className="form-group">
          <label htmlFor="formFile">Select CSV</label>
          <input
            className="form-control-file"
            type="file"
            id="formFile"
            name="formFile"
            accept=".csv"
            onChange={handleChange}
          />
        </div>
        <button
          type="submit"
          className="btn btn-block btn-info"
          disabled={!hasFiles}
        >
          Import CSV
        </button>
      </form>
      {isSubmitting && (
        <div className="d-flex flex-column justify-content-center align-items-center text-center mt-3 px-2">
          <div>
            <div className="spinner-border text-primary mb-2" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <strong>Uploading file</strong>
          <small>Please wait. Do not leave this page.</small>
          <small>You will be redirected automatically.</small>
        </div>
      )}
    </div>
  );
};
